import React from 'react';
import { AlertFloating } from './styles';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

export function WarningMicPermissionsCall() {
    return (
        <AlertFloating icon={<ErrorOutlineIcon />} severity='warning'>
            You must grant permissions for this site to use your microphone.  
            Once you grant permissions refresh the browser.
        </AlertFloating>
    );
}

export default WarningMicPermissionsCall;
